<template>
<v-card class="item-list">
    <v-card-actions>
        <v-dialog v-model="dialog">
            <template v-slot:activator="{ on, attrs }">
                <v-btn dark v-bind="attrs" v-on="on">
                    Not found? Create it!
                </v-btn>
            </template>

            <v-card>
                <v-card-text>
                    <ItemForm :event="event"/>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="dialog = false">
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card-actions>
    <v-card-text>
        <v-btn @click="updateInvitation()" v-if="selectedItems.length > 0" outlined>
            Bring selected to the event</v-btn>
        <v-autocomplete v-model="selectedItems" :items="filteredItems" attach dense cache-items autofocus solo clearable chips item-text="item_name" item-value="item_id" placeholder="type something" search-input="filter" multiple @update:search-input="searchItems"></v-autocomplete>
    </v-card-text>
</v-card>
</template>

<script>
import {
    mapState
} from "vuex";
import ItemForm from "@/components/molecules/ItemForm"

export default {
    components: {
        ItemForm
    },
    props: ["items", "event"],
    data() {
        return {
            filter: null,
            selectedItems: [],
            dialog: false,
        };
    },
    computed: mapState({
        ownProfile: (state) => state.profiles.ownProfile,
        filteredItems(state) {
            let items = this.event.invitations.find(
                (e) => e.invitee.id === state.profiles.ownProfile.id
            ).items;
            let itemIds = items.map((e) => e.item_id);
            if (this.filter) {
                let filtered_items = this.items.filter((e) =>
                    e.item_name.toLowerCase().includes(this.filter.trim().toLowerCase())
                );
                this.items = filtered_items;
            }
            let tempItems = [];
            for (const item of this.items) {
                if (!itemIds.includes(item.item_id)) {
                    tempItems.push(item);
                }
            }
            return tempItems;
        },
    }),
    methods: {
        searchItems(e) {
            this.$store.dispatch("getSearchMiscellaneous", e);
        },
        updateSelectedItems(item) {
            this.selectedItems.push(item);
        },
        async updateInvitation() {

            // Set up the invitation fields correctly.
            let tempInvitation = this.event.invitations.filter(
                (e) => e.invitee.id == this.ownProfile.id
            );
            tempInvitation = tempInvitation[0];
            tempInvitation.inv_event = tempInvitation.inv_event.event_id;
            tempInvitation.invitee = tempInvitation.invitee.id;
            tempInvitation.items = tempInvitation.items.map((e) => e.item_id);
            tempInvitation.games = tempInvitation.games.map((e) => e.item_id);

            tempInvitation.items.push(...this.selectedItems);
            await this.$store
                .dispatch("addMiscellaneous", {
                    ...tempInvitation
                })
                .then(() => this.$store.dispatch("eventDetails", this.event.event_slug))
                .then(() => (this.selectedItems = []));
        },
    },
};
</script>

<style scoped>
.item-list {
    min-height: 10px;
}
</style>
